import {
  defaultProductOrderMaterialLotDto,
  ProductOrderMaterialLotDto,
} from "src/dtos/prdOrderMaterialLot/ProductOrderMaterialLotDto";
import {
  defaultProductOrderDto,
  ProductOrderDto,
} from "src/dtos/productOrder/ProductOrderDto";

export interface KSK2130_R01Dto {
  productOrderHeaderDto: KSK2130_R01HeaderDto;
  productOrderMaterialLotDtoList: KSK2130_R01DetailDto[];
}

export interface KSK2130_R01HeaderDto extends ProductOrderDto {}

export interface KSK2130_R01DetailDto extends ProductOrderMaterialLotDto {
  logicCenter: string;
  warehouseCd: string;
  warehouseNm: string;
  itemNm: string;
  itemSpec: string;
  itemUnit: string;
  itemStatus: string;
  lotCreateDt: string;
  /** 상세 그리드 참조용 LOT의 현재 잔여 재고량이다. (저장하지 않는다.) */
  stockQty: number;
}

export const defaultKSK2130_R01HeaderDto: KSK2130_R01HeaderDto = {
  ...defaultProductOrderDto,
};

export const defaultKSK2130_R01DetailDto: KSK2130_R01DetailDto = {
  ...defaultProductOrderMaterialLotDto,
  logicCenter: "",
  warehouseCd: "",
  warehouseNm: "",
  itemNm: "",
  itemSpec: "",
  itemUnit: "",
  itemStatus: "",
  lotCreateDt: "",
  stockQty: 0,
};

export const defaultKSK2130_R01Dto: KSK2130_R01Dto = {
  productOrderHeaderDto: defaultKSK2130_R01HeaderDto,
  productOrderMaterialLotDtoList: [],
};
